import React from "react";

const UnblockStatus = ({environment, authenticating, unblocking, success, failed}) => {
    if (authenticating) {
        return <p className="authenticating">Authenticating...</p>
    }

    if (unblocking) {
        return <p className="unblocking">Unblocking this IP on {environment}...</p>
    }

    if (failed) {
        return <p className="failed">Failed to unblock this IP</p>
    }

    return <p className="success">Success! Your IP is unblocked.</p>
};

export default UnblockStatus;